export default __webpack_public_path__ + "static/media/Button-WStore.28bf7fcc.svg";